// var lazyLoadInstance = new LazyLoad({
//   elements_selector: ".lazy"
// });



var body = document.getElementsByTagName("body")[0];
var burger = document.getElementById('burger');

var header = document.getElementById('header');
var modal = document.getElementById('modal-bg');

var currHeight = window.innerHeight;
var newHeight = currHeight;

var cartPopup = document.getElementById('popupCart');

// Header Menu
burger.onclick = function () {
  header.classList.toggle('menu-open');

  if (!cartPopup.classList.contains('popup-cart-hidden')) {
    cartPopup.classList.add('popup-cart-hidden');
  }
}
modal.onclick = function () {
  header.classList.remove('menu-open');
}




// Product

// Product Header Scroll Hide
var totalHeight = body.offsetHeight;
var prevScrollpos = window.pageYOffset;
var productHeading = document.getElementsByClassName("product-heading")[0];

function headerHide() {
  var currentScrollPos = window.pageYOffset;
  if (prevScrollpos > currentScrollPos || currentScrollPos < 50 || currentScrollPos > (totalHeight - currHeight - 50)) {
    productHeading.classList.remove('product-header-open');
  } else {
    productHeading.classList.add('product-header-open');
  }
  prevScrollpos = currentScrollPos;
}


// Variants
function variantDropdown(event, option, value) {
  //event.currentTarget.classList.toggle('selector-open');
  var parent = document.getElementById('variant' + option);
  if (parent !== null) {
    parent.classList.toggle('variant-active');
  }

  // Which swatch is selected
  var activeSwatch = document.getElementById('swatch' + value);
  activeSwatch.classList.add('swatch-active');

}



function variantSelect(event, option, value, valueCamel, i) {
  var radios = document.querySelectorAll('[name="' + option + '"]');
  var dropdown = document.getElementsByClassName('selector-option')[i - 1];
  var dropdownTitle = document.getElementsByClassName('selected-option')[i - 1];
  
  var swatches = document.getElementsByClassName('variant-' + i);
  var activeSwatch = document.getElementById('swatch' + valueCamel);


  // Swatches
  for (n = 0; n < swatches.length; n++) {
    swatches[n].classList.remove('swatch-active');
  }
 
  activeSwatch.classList.add('swatch-active');


  // Removing checked attribute
  for (n = 0; n < radios.length; n++) {
    radios[n].removeAttribute('checked');
  }

  // Adding checked attribute to selected radio
  event.currentTarget.setAttribute('checked', 'checked');

  // Updating the dropdown text
  dropdownTitle.innerHTML = value;

  // Closing the dropdown
  dropdown.classList.toggle('selector-open');
}





// Swatches
function swatchShow(event, value) {
  var swatch = document.getElementById('swatch' + value);
  if (swatch !== null) {
    swatch.classList.add('swatch-hover-active');
  }
}


function swatchHide(event, value) {
  var swatch = document.getElementById('swatch' + value);
  if (swatch !== null) {
    swatch.classList.remove('swatch-hover-active');
  }
}




// Cart Notification
function cartNoteOpen(event) {  
  cartPopup.classList.remove('popup-cart-hidden');
}

function cartNoteClose(event) {
  cartPopup.classList.add('popup-cart-hidden');
}





// Contact Form

var enquireButton = document.getElementById('button-enquire');
var form = document.getElementById('contact-form');

enquireButton.onclick = function () {
  enquireButton.classList.toggle('menu-open');
  form.classList.toggle('menu-open');
}


// Meeting

var meetingButton = document.getElementById('button-meeting');
var meetingWrapper = document.getElementById('meeting-wrapper');

meetingButton.onclick = function () {
  meetingButton.classList.toggle('menu-open');
  meetingWrapper.classList.toggle('menu-open');
}







// var swiper = new Swiper('.swiper-container', {
//   loop: !0,
//   preventClicks: true,
//   preventClicksPropagation: true,
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'fraction',
//   },
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
//   keyboard: {
//     enabled: true,
//     onlyInViewport: true,
//   },
// });







// // Homepage Animation


// function setCookie(cname, cvalue, exdays) {
//   var d = new Date();
//   d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
//   var expires = "expires="+d.toUTCString();
//   document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
// }

// function getCookie(name) {
//   var dc = document.cookie;
//   var prefix = name + "=";
//   var begin = dc.indexOf("; " + prefix);
//   if (begin == -1) {
//     begin = dc.indexOf(prefix);
//     if (begin != 0) return null;
//   }
//   else {
//     begin += 2;
//     var end = document.cookie.indexOf(";", begin);
//     if (end == -1) {
//     end = dc.length;
//     }
//   }
//   return "";
// }

// function checkCookie() {
//   var animationCookie = getCookie("homeAnimation");

//   if (animationCookie == null) {
//     setCookie("homeAnimation", animationCookie, 1);
//   } else {
//     body.classList.add("hideanimation");
//     body.classList.remove("showanimation");
//   }
// }

